export const UPDATE_COLORS = "UPDATE_COLORS"
export const UPDATE_SOUND = "UPDATE_SOUND"
export const UPDATE_BACKGROUND_COLOR = "UPDATE_BACKGROUND_COLOR"
export const UPDATE_EFFECT = "UPDATE_EFFECT"
export const UPDATE_PRONUNCIATION = "UPDATE_PRONUNCIATION"
export const UPDATE_ALL_GENERAL = "UPDATE_ALL_GENERAL"
export const UPDATE_COLOR_MODE = "UPDATE_COLOR_MODE"
